import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-white" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16" data-id="element-68">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12" data-id="element-69">
          {/* Company Info */}
          <div data-id="element-70">
            <div className="mb-6" data-id="element-71">
              <img src="https://cdn.magicpatterns.com/uploads/m3EzG3aGX3C8qvhqEQC9KZ/2.png" alt="Manuel Technologies" className="h-10 w-auto" data-id="element-72" />
            </div>
            <p className="text-slate-400 leading-relaxed mb-6 text-sm sm:text-base" data-id="element-73">
              Driving digital transformation through AI-powered innovation and
              enterprise-grade technology solutions.
            </p>
            <div className="text-sm text-slate-400" data-id="element-74">RC 997980 • Est. 2011</div>
          </div>

          {/* Quick Links */}
          <div data-id="element-75">
            <h3 className="font-bold text-base sm:text-lg mb-6" data-id="element-76">Quick Links</h3>
            <ul className="space-y-3" data-id="element-77">
              <li data-id="element-78">
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-79">
                  About Us
                </Link>
              </li>
              <li data-id="element-80">
                <Link to="/services" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-81">
                  Services
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="/edo-case-study" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-83">
                  Edo Case Study
                </Link>
              </li>
              <li data-id="element-84">
                <Link to="/portfolio" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-85">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-86">
                <Link to="/clients" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-87">
                  Clients
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-88">
            <h3 className="font-bold text-base sm:text-lg mb-6" data-id="element-89">Services</h3>
            <ul className="space-y-3" data-id="element-90">
              <li data-id="element-91">
                <Link to="/services#ai" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-92">
                  AI & Machine Learning
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/services#software" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-94">
                  Software Development
                </Link>
              </li>
              <li data-id="element-95">
                <Link to="/services#cloud" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-96">
                  Cloud Solutions
                </Link>
              </li>
              <li data-id="element-97">
                <Link to="/services#security" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-98">
                  Cybersecurity
                </Link>
              </li>
              <li data-id="element-99">
                <Link to="/services#consulting" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-100">
                  IT Consulting
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-101">
            <h3 className="font-bold text-base sm:text-lg mb-6" data-id="element-102">Contact Us</h3>
            <ul className="space-y-4" data-id="element-103">
              <li className="flex items-start gap-3" data-id="element-104">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" data-id="element-105" />
                <div data-id="element-106">
                  <a href="mailto:info@manueltechnologies.com" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base break-all" data-id="element-107">
                    info@manueltechnologies.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-108">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" data-id="element-109" />
                <div data-id="element-110">
                  <a href="tel:+2348160027317" className="text-slate-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-111">
                    08160027317
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-112">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" data-id="element-113" />
                <div className="text-slate-400 text-sm sm:text-base" data-id="element-114">
                  Lagos, Nigeria
                </div>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex items-center gap-4 mt-6" data-id="element-115">
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors" data-id="element-116">
                <Linkedin className="w-5 h-5" data-id="element-117" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors" data-id="element-118">
                <Twitter className="w-5 h-5" data-id="element-119" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors" data-id="element-120">
                <Facebook className="w-5 h-5" data-id="element-121" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800" data-id="element-122">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left" data-id="element-123">
            <div className="text-slate-400 text-xs sm:text-sm" data-id="element-124">
              © 2026 Manuel Technologies and Global Investments Limited. All
              rights reserved.
            </div>
            <div className="flex items-center gap-4 sm:gap-6 text-xs sm:text-sm" data-id="element-125">
              <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors" data-id="element-126">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-slate-400 hover:text-white transition-colors" data-id="element-127">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}